import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import performanceManagementService from "@services/performanceManagement.service";
import strftime from "strftime";
import { Panel } from 'primereact/panel';
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);



// let data = {
//     "buket": value_ag,
//     "startDate": startDate,
//     "endDate": endDate,
//     "scope": level,
//     "ne_list": Array.from(newNode),
//     "kpi_id": Array.from(newKPI),
//     "tech": tech,
//     "times": times
//   };
export default function Chart(data) {
    console.log(data.headerName);
    const chartRef = useRef(null);
    const [header, setHeader] = useState("");
    const options = {
        exporting: {
            enabled: true,
            width: 1920
        },
        title: {
            text: "",
            margin: 50,

        },
        chart: {
            zoomType: "x",
            style: {
                fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
          "Helvetica Neue", Arial, "Noto Sans", sans-serif,
          "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
                height: "100%"
            },
            exporting: {
                enabled: false,
            },
        },
        credits: {
            enabled: false,
        },
        // colors: ["#2F5EC4", "#45a5f5"],
        plotOptions: {
            line: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3,
                    },
                },
                marker: {
                    enabled: false,
                },
            },
            series: {
                allowPointSelect: true,
                dataLabels: {
                    // enabled: true,
                    // formatter: function () {
                    //   var dataMax = this.series.dataMax;
                    //   if (this.y === dataMax) {
                    //     return this.y;
                    //   }
                    // },
                },
                cursor: 'pointer',


            },
        },
        time: {
            // useUTC: false,
            // timezone: "Asia/Tehran",
            timezoneOffset: -270,
        },
        yAxis: [
            {
                id: "left1",
                lineWidth: 1,
                title: {
                    enabled: false,
                }
            }
        ],
        xAxis: [
            {
                id: "bottom1",
                type: "datetime",
                labels: {
                    style: { fontWeight: "bold" },
                    rotation: 90,
                    // format: ""
                },
                lineWidth: 1,
                title: {
                    enabled: false,
                },
            }
        ],
        tooltip: {
            shared: true,
            crosshairs: true,
        },

        // legend: {
        //   enabled: false,
        // },
        series: [

        ],
    };

    useEffect(() => {
        let isMounted = true;
        
        // const start_mini = strftime("%m-%d", new Date(data.startDate));
        // const end_mini = strftime("%m-%d", new Date(data.endDate));
        // const date_mini = start_mini + "|" + end_mini;
        for (const chart of data.data) {
            // console.log("chart",chart);
            chartRef.current.chart.addSeries({
                type: "line",
                // id: chart_data.name,
                visible: true,
                yAxis: "left1",
                xAxis: "bottom1",
                name: chart.name,
                // color: counter.color,
                data:chart.data
            });
        }
        


        return () => { isMounted = false };
    }, []);
    return (
        <Panel  header={data.headerName}>
            <div className="flex p-5 w-full " style={{ maxWidth: "calc(100vw - 0)" }}>
                <div className="flex flex-col h-full w-full">
                    <div style={{ height: "100%" }}>
                        <HighchartsReact
                            ref={chartRef}
                            highcharts={Highcharts}
                            options={options}
                            updateArgs={[true, false, true]}
                            containerProps={{ style: { height: 'calc(100vh - 250px)' } }}
                        />
                    </div>
                </div>
            </div>
        </Panel>


    );
}